import styled from "styled-components";

export const FiguresRoot = styled.div`
  display: grid;
  width: 100%
  background: transparent;

  > * {
    grid-column-start: 1;
    grid-row-start: 1;
  }
`

export const Figures = styled.img`
  justify-self: center;
  max-width: 100%;
  object-fit: contain;
  grid-column: 1;
  grid-row: 1;
  z-index: 0;
`

export const Title = styled.div`
  font-family: "NeueMachina";
  font-size: 70px;
  min-width: 100%;
  text-align: justify;
  text-align-last: justify;
  letter-spacing: 2px;
  line-height: 1;  
  margin: 0;
  padding: 0;

  @media (max-width: 3300px) {
    font-size: 9rem;
  }

  @media (max-width: 2740px) {
      font-size: 8.5rem;
  }

  @media (max-width: 2590px) {
    font-size: 7.8rem;
  }

  @media (max-width: 2385px) {
    font-size: 6.8rem;
  }

  @media (max-width: 2120px) {
    font-size: 5.8rem;
  }

  @media (max-width: 1820px) {
      font-size: 4.8rem;
  }

  @media (max-width: 1540px) {
    font-size: 3.8rem;
}

  @media (max-width: 1280px) {
      font-size: 3rem;
  }

  @media (max-width: 1080px) {
    font-size: 2.7rem;
  }

  @media (max-width: 930px) {
    font-size: 2.3rem;
  }

  @media (max-width: 820px) {
    font-size: 1.9rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.7rem;
  }
`